import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Navegacao } from '../commons/navegacao';
import { AbTenant } from 'app/abstract/full-pages/admin/tenant.abstract';
import { DesignSystemSigmaService } from 'app/services/design-system-sigma.service';

@Injectable({ providedIn: 'root' })
export class TenantGuard implements CanActivate {

  constructor(
    private navegacao: Navegacao,
    private tenantService: AbTenant,
    private dssService: DesignSystemSigmaService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {

    if(this.dssService.isDssLayout()) {
      return true;
    }

    if (this.tenantService.getOnlyNumberIdenfiersTenant() == route.params.id) {
      return true;
    }

    this.navegacao.run([""]);
    return false;

  }

}
